import {Injectable} from '@angular/core';
import {Tab} from '@components/footer/tabs';
import {BehaviorSubject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class TabVisibilityService {
  private hiddenTabs = new Set<Tab>();
  private readonly _visibilityChanged$ = new BehaviorSubject<void>(undefined);
  public readonly visibilityChanged$ = this._visibilityChanged$.asObservable();

  constructor() {
    this.setGuestMode(false); // o true, se parte in modalità guest
  }

  setGuestMode(state: boolean) {
    if (state) {
      this.hideTab(Tab.Collection);
      this.hideTab(Tab.Profile);
      this.showTab(Tab.Guest);
      this.showTab(Tab.Login);
      this._visibilityChanged$.next(); // notifica aggiornamento
    } else {
      this.showTab(Tab.Collection);
      this.showTab(Tab.Profile);
      this.hideTab(Tab.Guest);
      this.hideTab(Tab.Login);
      this._visibilityChanged$.next(); // notifica aggiornamento
    }
  }

  hideTab(key: Tab): void {
    this.hiddenTabs.add(key);
    this._visibilityChanged$.next(); // notifica aggiornamento
  }

  showTab(key: Tab): void {
    if (this.hiddenTabs.delete(key)) {
      this._visibilityChanged$.next(); // solo se effettivamente rimosso
    }
  }

  isTabHidden(key: Tab): boolean {
    return this.hiddenTabs.has(key);
  }

  getHiddenTabKeys(): Tab[] {
    return Array.from(this.hiddenTabs);
  }

  reset(): void {
    if (this.hiddenTabs.size > 0) {
      this.hiddenTabs.clear();
      this._visibilityChanged$.next(); // notifica reset
    }
  }
}
